import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { useTranslation } from "react-i18next";
import { ReportViewerTypeDistributionProps } from "../types";

export function ReportViewerTypeDistribution({
  data,
}: ReportViewerTypeDistributionProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-blue-600">📋</span>
          {translate("report-viewer-type-distribution-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {data.map((item) => (
            <div key={item.name} className="flex items-center justify-between">
              <div className="flex items-center gap-3 flex-1">
                <span className="font-medium min-w-[120px]">{item.name}</span>
                <div className="flex-1 h-6 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full transition-all duration-500"
                    style={{
                      width: `${item.percentage}%`,
                      backgroundColor: item.color,
                    }}
                  />
                </div>
                <span className="font-bold text-lg min-w-[60px] text-right">
                  {item.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
